import React from 'react';
import {
  Apartment as ApartmentIcon,
  LocalOffer as LocalOfferIcon,
  Percent as PercentIcon,
  RequestQuote as ValuationIcon,
  ThumbUpAlt as ThumbUpIcon,
} from '@mui/icons-material';
import type { ShareLinkFeature } from '../../services/api';

/** One icon per building block, shared by the create dialog and the link cards. */
export const FEATURE_ICONS: Record<ShareLinkFeature, React.ReactNode> = {
  PRICE_PROMO_NEARBY: <LocalOfferIcon />,
  THUMBSUP_NEARBY: <ThumbUpIcon />,
  VALUATION: <ValuationIcon />,
  PROJECT_REQUEST: <ApartmentIcon />,
  SUPER_RATIO: <PercentIcon />,
};
